export { default } from './TextWithImageSlider'
